// boot-binding.js — pure pick of the conversation the hosted boot binds to.
// The list endpoint orders by created_at ASC, so the legacy "last element" pick
// bound the newest-CREATED conversation — not the one the user was working in,
// and (with chat resume on) not the one whose run is still streaming. Order of
// preference here: a conversation with a live run (latest started_at among
// several), else the latest activity (last_active_at, falling back to
// created_at for never-active rows), else the legacy last element.
// No DOM; unit-tested in boot-binding.test.mjs.

/** Timestamp value for comparison: epoch numbers pass through, ISO strings are
 *  parsed, anything absent/unparseable sorts below every real timestamp. */
function ts(v) {
  if (typeof v === "number" && Number.isFinite(v)) return v;
  if (typeof v === "string") {
    const t = Date.parse(v);
    return Number.isNaN(t) ? -Infinity : t;
  }
  return -Infinity;
}

/** The conversation the boot should bind to, or null for an empty list. */
export function pickBootConversation(conversations) {
  if (!Array.isArray(conversations)) return null;
  const rows = conversations.filter(Boolean);
  if (!rows.length) return null;
  const running = rows.filter((c) => c.active_run);
  const pool = running.length ? running : rows;
  const key = running.length
    ? (c) => ts(c.active_run.started_at)
    : (c) => {
        const active = ts(c.last_active_at);
        return active === -Infinity ? ts(c.created_at) : active;
      };
  let best = pool[0];
  let bestKey = key(best);
  for (const c of pool.slice(1)) {
    const k = key(c);
    if (k >= bestKey) {
      // >= : ties keep the later element, degenerating to the legacy pick
      best = c;
      bestKey = k;
    }
  }
  return best;
}
